import Vue from "vue"
import Router from "vue-router"
import routes from "@/router/routes"
import store from "@/store/index"
import jwt_decode from "jwt-decode"
import { ToastProgrammatic as Toast } from 'buefy'


Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

function assertAlive (decoded) {
  const now = Date.now().valueOf() / 1000
  if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
    // Clear authentication state when token expires
    store.commit("account/reset");
    Toast.open({
      duration: 1000,
      message: "Your session has expired",
      position: "is-top",
      type: "is-dark",
    })
    return false;
  }
  return true;
}

function checkLogin() {
  let isAuthenticated = store.get("account/isAuthenticated")
  let accessToken = store.get("account/accessToken")

  try{
    let decoded = jwt_decode(accessToken);
    return isAuthenticated && assertAlive(decoded);
  }
  catch(Error){
      return false;
  }
}

// route checks for authentication and redirects
router.beforeEach((routeTo, routeFrom, next) => {
  const requiresAuth = routeTo.matched.some((route) => route.meta.requiresAuth)
  const redirectIfAuthenticated = routeTo.matched.some(
    (route) => route.meta.redirectIfAuthenticated
  )
  // If auth isn't required for the route, just continue.
  if (!requiresAuth && !redirectIfAuthenticated) return next()

  let isLoginValid = checkLogin();

  if (requiresAuth && !isLoginValid) {
    // Avoid redundant navigation to login
    if (routeTo.path !== "/login") {
      return next("/login")
    }
    return next()
  }

  if (isLoginValid && redirectIfAuthenticated) {
    return next("/")
  }
  
  return next()
})

export default router
